import "./App.css"
import { render } from "solid-js/web"
import { Router } from "@solidjs/router"
import App, { AppRouteTable } from "./App"
import { TrackingProvider } from "./shared/providers/tracking.provider"
import * as Sentry from "@sentry/browser"
import { DEV } from "solid-js"
import { environment, IntercomAppId, ReleaseTag } from "./config"

Sentry.init({
  dsn: "https://1c83a39ba7876710b56ec325061dbbd6@o4507035087273984.ingest.us.sentry.io/4509088027377664",
  release: ReleaseTag !== "" ? ReleaseTag : undefined,
  environment,
  initialScope: { tags: { "pt.surface": "webinar-funnel" } },
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !DEV,
  ignoreErrors: [
    "Called on script loaded before session recording is available",
    "bufferBelongsToIframe",
    "Blocked a frame with origin",
    "Invalid call to runtime.sendMessage",
    "Could not establish connection. Receiving end does not exist",
    "Not implemented on this platform",
    "_AutofillCallbackHandler",
    "Java object is gone",
    "data-jam-capture",
  ],
  denyUrls: [
    /profitwell\.js/,
    /public\.profitwell\.com/,
    /beacon\.min\.js/,
    /frame-modern\..*\.js/,
    /app~tooltips-modern/,
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-(web-)?extension:\/\//,
    /^iabjs:\/\//,
    /\.safariextension\//,
  ],
})

const root = document.getElementById("root")

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?"
  )
}

const addIntercomSnippet = (): void => {
  window.intercomSettings = {
    app_id: IntercomAppId,
  }
  ;(function () {
    const w = window
    const ic = w.Intercom
    if (typeof ic === "function") {
      ic("reattach_activator")
      ic("update", w.intercomSettings)
    } else {
      const d = document
      const i = ((...args: unknown[]) => {
        i.c(args)
      }) as Window["Intercom"] & { q: unknown[][]; c: (args: unknown[]) => void }
      i.q = []
      i.c = (args: unknown[]) => {
        i.q.push(args)
      }
      w.Intercom = i
      const l = (): void => {
        const s = d.createElement("script")
        s.type = "text/javascript"
        s.async = true
        s.src = "https://widget.intercom.io/widget/" + IntercomAppId
        const x = d.getElementsByTagName("script")[0]
        x?.parentNode?.insertBefore(s, x)
      }
      if (document.readyState === "complete") {
        l()
      } else {
        w.addEventListener("load", l, false)
      }
    }
  })()
}

addIntercomSnippet()

render(
  () => (
    <Router
      root={(props) => (
        <TrackingProvider>
          <App {...props} />
        </TrackingProvider>
      )}
    >
      <AppRouteTable />
    </Router>
  ),
  root!
)
